<!-- Further explanation of an answer, hidden behind an icon -->
<template>
    <div
        data-tooltip
        role="tooltip"
        tabindex="-1"
        @keydown.space.prevent
        @keyup.space="showDescription = !showDescription"
        @focus="isMobile ? null : showDescription = true"
        @blur="isMobile ? null : showDescription = false"
        aria-live="polite"
        :aria-label="descriptions"
        :id="id"
    >
        <font-awesome-icon
            data-icon
            @mouseover="isMobile ? null : showDescription = true"
            @focus="isMobile ? null : showDescription = true"
            @mouseleave="isMobile ? null : showDescription = false"
            @click.stop.prevent="showDescription = !showDescription"
            @blur="isMobile ? null : showDescription = false"
            icon="info"
            aria-hidden="true"
            ref="tooltip"
            tab-index="-1"
        />
        <transition name="fade">
            <div v-if="showDescription" data-tooltip-description :data-position="position">
                <p
                    v-html="DOMPurify.sanitize(descriptions)"
                    data-text
                    :id="id.replace(`_description`, `_description-text`)"
                ></p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: `answer-description`,
    inject: ['DOMPurify'],
    data() {
        return {
            showDescription: false,
            position: ``,
            isMobile: false,
            windowWidth: ``,
        };
    },
    props: {
        answerData: {
            type: Object,
        },
        questionData: {
            type: Object,
        },
        sq: {
            type: Object,
        },
    },
    watch: {
        showDescription: function () {
            let posWidth = this.$refs.tooltip.getBoundingClientRect().x + 300;

            if (posWidth > this.windowWidth) {
                this.position = `left`;
            }
            if (posWidth < this.windowWidth) {
                this.position = `right`;
            }
            if (this.windowWidth <= 460) {
                this.position = `top`;
            }
        },
    },
    computed: {
        id: function () {
            let id = ``;
            if (this.questionData && this.sq && this.answerData) {
                id += `question-${this.questionData.number}_sq-${this.sq.number}_checkradio-answer-${this.answerData.number}`;
            } else if (this.sq) {
                id += `question-${this.questionData.number}_sq-${this.sq.number}_description`;
            } else if (this.answerData) {
                id += `question-${this.questionData.number}_description-${this.answerData.number}`;
            }
            return id;
        },
        descriptions: function () {
            if (this.answerData && this.answerData.description) {
                return this.answerData.description;
            } else if (this.sq && this.sq.subQuestionDescription) {
                return this.sq.subQuestionDescription;
            } else {
                return ``;
            }
        },
    },
    methods: {
        checkForMobile: function () {
            this.isMobile = this.$store.state.global.windowSize < 500;
        },
    },
    created() {
        this.windowWidth = this.$store.state.global.windowSize;
        this.checkForMobile();
        window.addEventListener(`resize`, this.checkForMobile);
    },
};
</script>

<style scoped>
[data-tooltip] {
    display: flex;
    margin-left: 25px;
    cursor: pointer;

    svg:hover {
        background: var(--primary-color);
    }
}

[data-icon] {
    background: #d1d1d1;
    width: 21px;
    height: 21px;
    padding: 5px;
    border-radius: 5px;

    path {
        color: white;
    }
}

[data-tooltip-description] {
    max-width: 300px;
    width: 100%;
    background: white;
    z-index: 1;
    color: #454848;
    font-size: 16px;
    padding: 15px 20px;
    border-radius: 4px;
    position: absolute;
    box-shadow: 0 0 8px #00000029;

    [data-text] {
        word-break: break-word;
        word-wrap: break-word;
        margin: 0;
    }
}

[data-position="left"] {
    margin-left: -308px;
}

[data-position="right"] {
    margin-left: 30px;
}

[data-position="top"] {
    left: 0;
    margin-top: 30px;
    max-width: 250px;
    width: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>